import React, {useContext, useEffect, useState} from 'react'
import headbandContext from 'contexts/headband'
import "./guidePratique.scss"
import HeadbandTitle from 'components/headband/headbandTitle'
import BigButtonPopup from 'components/buttons/bigButtonPopup'
import BigButton from 'components/buttons/bigButton'
import Popup from 'reactjs-popup'
import ClosePopupBtn from 'components/buttons/closePopupBtn'
export default function GuidePratique(props) {
    const {setCounter, counterDefault} = props
    const {setHeadband} = useContext(headbandContext)
    useEffect(() => {
        setHeadband({
            title :  "Le guide pratique",
            icon : "picto guide pratique - v2.svg",
            color : "bckDarkBlue"
        })
    }, [])
    const [opacity, setOpacity] = useState(0)
    useEffect(() => {
        setTimeout(() => {
            setOpacity(1)
        }, 50)
    }, [])
    return (
        <div id="guidePratique"  className='page'>
            <h2>La formation en pratique</h2>
            <ul>
                <li>
                    <img className="bulle" src="/picto_bulle_interrogation.svg" alt="" style={{opacity : opacity}}  />
                    <p><span>Se renseigner auprès de qui ?</span> Votre cadre, le pôle de formation continue.</p>
                </li>
                <li>
                    <img className="bulle" src="/picto_bulle_interrogation.svg" alt="" style={{opacity : opacity}}  />
                    <p><span>Pour quoi ?</span>  Vous aider à faire le point, à renforcer
                    vos compétences, à changer de métier.</p>
                </li>
                <li>
                    <img className="bulle" src="/picto_bulle_interrogation.svg" alt="" style={{opacity : opacity}}  />
                    <p><span>Quand ?</span> Pendant l’entretien annuel d’évaluation et de formation.</p>
                </li>
                <li>
                    <img className="bulle" src="/picto_bulle_video.svg" alt="" style={{opacity : opacity}}  />
                    <p><span>Une vidéo pédagogique est disponible</span></p>
                </li>
                <Popup 
                    trigger={
                        <li style={{paddingLeft : "130px"}}>
                            <BigButtonPopup title="Bien formuler sa demande de formation" icon="picto lecteur video - v2.svg" background="bckDarkBlue"/>    
                        </li>
                    }
                    modal
                    closeOnDocumentClick
                >
                    {
                        close => (
                            <div className='w100'>
                                <video src="/videos/video.mp4" onPlay={() => setCounter(250)} autoPlay loop></video>
                                <ClosePopupBtn close={close} />
                            </div>
                        )
                    }
                </Popup>
                <li>
                    <img className="bulle" src="/picto_bulle_interrogation.svg" alt="" style={{opacity : opacity}}  />
                    <p><span>Où trouver la formation qui vous convient ? </span> Dans le plan de formation de l’établissement qui intègre les actions de formations institutionnelles.</p>
                </li>
                <li>
                    <img className="bulle" src="/picto_bulle_euro.svg" alt="" style={{opacity : opacity}}  />
                    <p><span>Où trouver la formation qui vous convient ? </span> Dans le plan de formation de l’établissement qui intègre les actions de formations institutionnelles.</p>
                </li>
                <li style={{top : "150px"}} className="liVideo">
                    <img className="bulle" src="/picto_bulle_interrogation.svg" alt="" style={{opacity : opacity}}  />
                    <p><span>Qui contacter ? </span></p>
                    <BigButton title="Fiche contact" icon={"picto_fiche_contact.svg"} page={"/accueil/drhf/fiche_contact"} background="bckDarkBlue" headbandBackground={"bckGreen"} />
                </li>
            </ul>
        </div>
    )
}
